import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-lightning-icon-cell',
    template: `
        <p-checkbox binary="true" [(ngModel)]="params.data.isLiquidate" [disabled]="disabled"
                    (onChange)="onChange($event)"></p-checkbox>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class customCheckboxCellRenderer implements AgRendererComponent {

    params: any;
    disabled: boolean;

    constructor() {
    }

    agInit(params: any) {
        this.params = params;
        this.disabled = params.data.accountType === 'EXTERNAL' || params.data.isSMA;
    }


    refresh(): boolean {
        return false;
    }

    onChange(event: any) {
        if (event.checked) {
            if (this.params.data.isFrozen) {
                this.params.parent.frozenAccountAlertDialog(this.params.data.accountNumber);
            }
            this.params.node.setDataValue('extraCashAmount', this.params.data.accountMarketValue);
        } else {
            this.params.node.setDataValue('extraCashAmount', null);
        }
        this.params.api.redrawRows({rowNodes: [this.params.node]});

    }
}
